<i18n
  src="@/locales/views/agro_exporter/providers/producers/new_producer.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_producers')"
    :params="{
      agro_exporter_id: agro_exporter_id
    }"
  />
  <bread-crumbs :labels="[module_name]"></bread-crumbs>

  <alert-danger :errors_data="std_err" />

  <div class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-6">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.producer.agro_exporter_producer.producer_code") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model.trim="agro_exporter_producer.producer_code"
                  :class="[
                    'input-text',
                    isInvalid('agro_exporter_producer[producer_code]')
                  ]"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.producer.producer_code") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model.trim="producer_code"
                  :class="['input-text', isInvalid('producer_code')]"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.producer.lastname") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model.trim="lastname"
                  :class="['input-text', isInvalid('lastname')]"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.producer.name") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model.trim="name"
                  :class="['input-text', isInvalid('name')]"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.producer.gender_id") }}
              </label>
              <div class="mt-3">
                <radio-form
                  v-model="gender_id"
                  name="gender_id"
                  :options="genders"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <div class="mt-3">
                <switch-form
                  v-model="agro_exporter_producer.active"
                  :label="$t('model.producer.agro_exporter_producer.active')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <div class="panel-footer-actions">
          <white-button
            @click.prevent="goToListProducers()"
            :label="$t('labels.cancel_button')"
          />
          <span class="space-actions"></span>
          <success-button
            v-if="!proc_save_button"
            @click.prevent="create()"
            :label="$t('labels.save_button')"
          />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/providers/producers/manage_producers.js";
import GenderMixin from "@/components/views/mixins/organization/genders.js";

export default {
  name: "AEProvidersProducersNewProducer",
  mixins: [GenderMixin],
  data() {
    return {
      proc_save_button: false,
      producer_code: null,
      lastname: "",
      name: "",
      gender_id: null,
      birth_date: null,
      agro_exporter_producer: { producer_code: null, active: true }
    };
  },
  props: {
    agro_exporter_id: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      })
    );
  },
  methods: {
    create: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.createProducer(this.agro_exporter_id, {
          producer_code: this.producer_code,
          name: this.name,
          lastname: this.lastname,
          gender_id: this.gender_id,
          agro_exporter_producer: this.agro_exporter_producer
        });

        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowProducer(response.data.producer_id);
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
        this.proc_save_button = false;
      }
    },
    goToShowProducer: function (producer_id) {
      this.$router.push({
        name: this.routeName("show_producer"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          producer_id: producer_id
        }
      });
    },
    goToListProducers: function () {
      this.$router.push({
        name: this.routeName("list_producers"),
        params: {
          agro_exporter_id: this.agro_exporter_id
        }
      });
    }
  }
};
</script>
